import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { LineDashboardRoutingModule } from './line-dashboard-routing.module';
import { LineDashboardComponent } from './line-dashboard.component';
import { MatIconModule } from '@angular/material/icon';
import { RequesterService } from './services/requester.service';
import { StackedBarChartComponent } from './components/stacked-bar-chart/stacked-bar-chart.component';

@NgModule({
  declarations: [LineDashboardComponent, StackedBarChartComponent],
  imports: [
    CommonModule,
    LineDashboardRoutingModule,
    SharedModule,
    MatIconModule
  ],
  providers: [
    RequesterService
  ]
})
export class LineDashboardModule { }
